import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var transferStyle = function transferStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary1 = _getThemeData.primary1,
    primary6 = _getThemeData.primary6,
    primary4 = _getThemeData.primary4;
  return css([".ant-transfer.ant-transfer{.ant-transfer-list-content-item:not(.ant-transfer-list-content-item-disabled):hover{background-color:", ";}.ant-transfer-list-content > .LazyLoad{animation:none;}.ant-transfer-operation{button:not([disabled]){:hover,:focus{background-color:", ";color:#fff;}:active{background-color:", ";color:#fff;}}}}"], primary1, primary4, primary6);
};
export default transferStyle;